import { useCallback } from 'react';
import type { ActionHandlerType, OnActionArgs } from '../../../../context/ActionsProvider/context';
import type { GlobalStateStoreFlows } from '../../../../stores/GlobalStateStore';
import { useGetGlobalStateStoreStateByInstanceId } from '../../../../stores/GlobalStateStore';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

function useControlMediaViewer() {
  const getGlobalStateStoreState = useGetGlobalStateStoreStateByInstanceId();
  const { getNoCodeComputedData } = useGetNoCodeComputedData();

  const controlMediaViewer: ActionHandlerType = useCallback(
    ({ action, actionContext, instanceId }: OnActionArgs) => {
      const { actions } = getGlobalStateStoreState(instanceId);
      const payload = action.payload as GlobalStateStoreFlows['controlMediaViewer'];
      const computedPayload = getNoCodeComputedData<GlobalStateStoreFlows['controlMediaViewer']>(
        payload ?? {},
        actionContext,
      );

      if (payload?.url || payload?.mappedMediaItems) {
        return new Promise<boolean>((resolve, reject) => {
          actions.setPreBuiltFlow({
            type: 'controlMediaViewer',
            data: {
              ...computedPayload,
              onSuccess: () => resolve(SHOULD_NOT_PROPAGATE_UP),
              onClose: () => resolve(SHOULD_NOT_PROPAGATE_UP),
              onError: () => reject(SHOULD_NOT_PROPAGATE_UP),
            },
          });
        });
      }

      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
    [getNoCodeComputedData, getGlobalStateStoreState],
  );

  return { controlMediaViewer };
}

export default useControlMediaViewer;
